import React, { useState } from "react";

import "./stylesTargetAudiences.css";
import { Checkbox, Input, Select } from "antd";

import ToggleSwitch from "../../../CommonComponents/ToggleSwitch/ToggleSwitch";

const statesOptions = [
  { value: "All states", label: "All states" },
  { value: "Alabama", label: "Alabama" },
  { value: "Alaska", label: "Alaska" },
  { value: "Arizona", label: "Arizona" },
  { value: "Arkansas", label: "Arkansas" },
  { value: "California", label: "California" },
  { value: "Colorado", label: "Colorado" },
  { value: "Connecticut", label: "Connecticut" },
  { value: "Delaware", label: "Delaware" },
  { value: "Florida", label: "Florida" },
  { value: "Georgia", label: "Georgia" },
  { value: "Hawaii", label: "Hawaii" },
  { value: "Idaho", label: "Idaho" },
  { value: "Illinois", label: "Illinois" },
  { value: "Indiana", label: "Indiana" },
  { value: "Iowa", label: "Iowa" },
  { value: "Kansas", label: "Kansas" },
  { value: "Kentucky", label: "Kentucky" },
  { value: "Louisiana", label: "Louisiana" },
  { value: "Maine", label: "Maine" },
  { value: "Maryland", label: "Maryland" },
  { value: "Massachusetts", label: "Massachusetts" },
  { value: "Michigan", label: "Michigan" },
  { value: "Minnesota", label: "Minnesota" },
  { value: "Mississippi", label: "Mississippi" },
  { value: "Missouri", label: "Missouri" },
  { value: "Montana", label: "Montana" },
  { value: "Nebraska", label: "Nebraska" },
  { value: "Nevada", label: "Nevada" },
  { value: "New Hampshire", label: "New Hampshire" },
  { value: "New Jersey", label: "New Jersey" },
  { value: "New Mexico", label: "New Mexico" },
  { value: "New York", label: "New York" },
  { value: "North Carolina", label: "North Carolina" },
  { value: "North Dakota", label: "North Dakota" },
  { value: "Ohio", label: "Ohio" },
  { value: "Oklahoma", label: "Oklahoma" },
  { value: "Oregon", label: "Oregon" },
  { value: "Pennsylvania", label: "Pennsylvania" },
  { value: "Rhode Island", label: "Rhode Island" },
  { value: "South Carolina", label: "South Carolina" },
  { value: "South Dakota", label: "South Dakota" },
  { value: "Tennessee", label: "Tennessee" },
  { value: "Texas", label: "Texas" },
  { value: "Utah", label: "Utah" },
  { value: "Vermont", label: "Vermont" },
  { value: "Virginia", label: "Virginia" },
  { value: "Washington", label: "Washington" },
  { value: "West Virginia", label: "West Virginia" },
  { value: "Wisconsin", label: "Wisconsin" },
  { value: "Wyoming", label: "Wyoming" },
];

const additionalFilters = [
  { value: "High Churn Risk", label: "High Churn Risk" },
  { value: "Medium Churn Risk", label: "Medium Churn Risk" },
  { value: "Low Churn Risk", label: "Low Churn Risk" },
  { value: "High Reactivation Score", label: "High Reactivation Score" },
  { value: "Medium Reactivation Score", label: "Medium Reactivation Score" },
  { value: "Low Reactivation Score", label: "Low Reactivation Score" },
  { value: "Daily Active", label: "Daily Active" },
  { value: "Weekly Active", label: "Weekly Active" },
  { value: "Monthly Active", label: "Monthly Active" },
  { value: "Infrequent User", label: "Infrequent User" },
  { value: "Low Staker", label: "Low Staker" },
  { value: "Medium Staker", label: "Medium Staker" },
  { value: "High Staker", label: "High Staker" },
  { value: "VIP/High Roller", label: "VIP/High Roller" },
  { value: "Slots Dominant", label: "Slots Dominant" },
  { value: "Table Games Dominant", label: "Table Games Dominant" },
  { value: "Live Dealer Dominant", label: "Live Dealer Dominant" },
  { value: "Sports Betting Dominant", label: "Sports Betting Dominant" },
  { value: "Mixed Player", label: "Mixed Player" },
  { value: "Highly Bonus Responsive", label: "Highly Bonus Responsive" },
  {
    value: "Occasionally Bonus Responsive",
    label: "Occasionally Bonus Responsive",
  },
  { value: "Non-Responsive to Bonuses", label: "Non-Responsive to Bonuses" },
  { value: "First-Time Depositor", label: "First-Time Depositor" },
  { value: "Frequent Depositor", label: "Frequent Depositor" },
  { value: "Lapsed Depositor", label: "Lapsed Depositor" },
  { value: "Bonus-Only Depositor", label: "Bonus-Only Depositor" },
  { value: "Light Bettor", label: "Light Bettor" },
  { value: "Moderate Bettor", label: "Moderate Bettor" },
  { value: "Heavy Bettor", label: "Heavy Bettor" },
  { value: "Inconsistent Bettor", label: "Inconsistent Bettor" },
  { value: "Net Winner", label: "Net Winner" },
  { value: "Net Loser", label: "Net Loser" },
  { value: "Break-Even Player", label: "Break-Even Player" },
  { value: "High Variance Player", label: "High Variance Player" },
  { value: "Frequent Cashouts", label: "Frequent Cashouts" },
  { value: "Rare Cashouts", label: "Rare Cashouts" },
  { value: "No Cashout History", label: "No Cashout History" },
  {
    value: "High Cashout-to-Deposit Ratio",
    label: "High Cashout-to-Deposit Ratio",
  },
  { value: "Mobile Only", label: "Mobile Only" },
  { value: "Desktop Only", label: "Desktop Only" },
  { value: "Multi-Device User", label: "Multi-Device User" },
  { value: "App User", label: "App User" },
  { value: "Browser User", label: "Browser User" },
  { value: "Daytime Player", label: "Daytime Player" },
  { value: "Evening Player", label: "Evening Player" },
  { value: "Overnight Player", label: "Overnight Player" },
  { value: "Weekday User", label: "Weekday User" },
  { value: "Weekend User", label: "Weekend User" },
  {
    value: "Newly Registered (0–7 days)",
    label: "Newly Registered (0–7 days)",
  },
  {
    value: "Early Lifecycle (8–30 days)",
    label: "Early Lifecycle (8–30 days)",
  },
  {
    value: "Established User (31–90 days)",
    label: "Established User (31–90 days)",
  },
  { value: "VIP Player", label: "VIP Player" },
  {
    value: "Dormant User (30+ days inactive)",
    label: "Dormant User (30+ days inactive)",
  },
  { value: "Reactivated Player", label: "Reactivated Player" },
  {
    value: "Churning Player (activity decline >50%)",
    label: "Churning Player (activity decline >50%)",
  },
  { value: "Never Claimed Bonus", label: "Never Claimed Bonus" },
  { value: "Recently Claimed Bonus", label: "Recently Claimed Bonus" },
  { value: "Bonus Abuser Flag", label: "Bonus Abuser Flag" },
  { value: "Incomplete Bonus Wagering", label: "Incomplete Bonus Wagering" },
  {
    value: "Bonus Expired Without Usage",
    label: "Bonus Expired Without Usage",
  },
  { value: "High Bonus Conversion", label: "High Bonus Conversion" },
  { value: "Consistent Depositor", label: "Consistent Depositor" },
  { value: "Retention Anchor", label: "Retention Anchor" },
  { value: "Late Night Loyal", label: "Late Night Loyal" },
  { value: "Weekend Warrior", label: "Weekend Warrior" },
  { value: "Social Gamer", label: "Social Gamer" },
  { value: "Multi-Vertical Retained", label: "Multi-Vertical Retained" },
  { value: "Bonus-Driven Retained", label: "Bonus-Driven Retained" },
  { value: "Organic Retained", label: "Organic Retained" },
  { value: "Recent Win Retainer", label: "Recent Win Retainer" },
  { value: "Gamified Retainer", label: "Gamified Retainer" },
  { value: "Dormant <30 days", label: "Dormant <30 days" },
  { value: "Dormant 30–90 days", label: "Dormant 30–90 days" },
  { value: "Dormant 90+ days", label: "Dormant 90+ days" },
  { value: "Past VIP, Now Dormant", label: "Past VIP, Now Dormant" },
  { value: "Bonus Expired, No Return", label: "Bonus Expired, No Return" },
  {
    value: "Last Seen During Major Event",
    label: "Last Seen During Major Event",
  },
  { value: "Deposited But Never Played", label: "Deposited But Never Played" },
  { value: "One-Time Bonus User", label: "One-Time Bonus User" },
  {
    value: "Active in Sports, Dormant in Casino",
    label: "Active in Sports, Dormant in Casino",
  },
  {
    value: "Active in Casino, Dormant in Sports",
    label: "Active in Casino, Dormant in Sports",
  },
  { value: "Tilting Player", label: "Tilting Player" },
  { value: "Hot Streak", label: "Hot Streak" },
  { value: "Cold Streak", label: "Cold Streak" },
  { value: "Big Bet Spike", label: "Big Bet Spike" },
  { value: "Deposit–Wager Gap", label: "Deposit–Wager Gap" },
  { value: "Cart Abandoner", label: "Cart Abandoner" },
  { value: "Streamer-Fueled Activity", label: "Streamer-Fueled Activity" },
  { value: "Multi-Bet Pattern", label: "Multi-Bet Pattern" },
  { value: "Chasing Losses", label: "Chasing Losses" },
  {
    value: "High Session Count, Low Wager",
    label: "High Session Count, Low Wager",
  },
  { value: "Single Bet Dominant", label: "Single Bet Dominant" },
  { value: "Parlay/Multi Bet Dominant", label: "Parlay/Multi Bet Dominant" },
  { value: "In-Play Bettor", label: "In-Play Bettor" },
  { value: "Pre-Match Bettor", label: "Pre-Match Bettor" },
  { value: "Cashout User", label: "Cashout User" },
  { value: "High Odds Hunter", label: "High Odds Hunter" },
  { value: "Low Margin Bettor", label: "Low Margin Bettor" },
  { value: "Live Event Bettor", label: "Live Event Bettor" },
  { value: "Football Bettor", label: "Football Bettor" },
  { value: "Basketball Bettor", label: "Basketball Bettor" },
  { value: "Tennis Bettor", label: "Tennis Bettor" },
  { value: "UFC Bettor", label: "UFC Bettor" },
  { value: "Niche Sports Bettor", label: "Niche Sports Bettor" },
  {
    value: "Seasonal/Event-Based Sports Bettor",
    label: "Seasonal/Event-Based Sports Bettor",
  },
  { value: "Slot Grinder", label: "Slot Grinder" },
  { value: "Big Win Chaser", label: "Big Win Chaser" },
  { value: "Table Game Loyalist", label: "Table Game Loyalist" },
  { value: "Live Dealer Enthusiast", label: "Live Dealer Enthusiast" },
  { value: "New Game Explorer", label: "New Game Explorer" },
  { value: "Sticky Game Player", label: "Sticky Game Player" },
  { value: "Quick Dropper", label: "Quick Dropper" },
  { value: "Autoplay Addict", label: "Autoplay Addict" },
  { value: "Bonus Hunter", label: "Bonus Hunter" },
  { value: "Jackpot Chaser", label: "Jackpot Chaser" },
  { value: "Esports-Only Bettor", label: "Esports-Only Bettor" },
  { value: "Cross-Market Bettor", label: "Cross-Market Bettor" },
  { value: "Streamer-Driven Bettor", label: "Streamer-Driven Bettor" },
  { value: "CS:GO Bettor", label: "CS:GO Bettor" },
  { value: "League of Legends Bettor", label: "League of Legends Bettor" },
  { value: "Dota 2 Bettor", label: "Dota 2 Bettor" },
  { value: "Valorant Bettor", label: "Valorant Bettor" },
  { value: "Call of Duty Bettor", label: "Call of Duty Bettor" },
  {
    value: "Tournament-Focused Esports Bettor",
    label: "Tournament-Focused Esports Bettor",
  },
  {
    value: "Skin-to-Cash Conversion User",
    label: "Skin-to-Cash Conversion User",
  },
  { value: "In-Play Esports Bettor", label: "In-Play Esports Bettor" },
  { value: "Parlay Esports Bettor", label: "Parlay Esports Bettor" },
  { value: "Esports VIP", label: "Esports VIP" },
  {
    value: "Young & Mobile-First Esports Fan",
    label: "Young & Mobile-First Esports Fan",
  },
  { value: "Free to play Player", label: "Free to play Player" },
  { value: "Retention Segments (C1-C9)", label: "Retention Segments (C1-C9)" },
  {
    value: "Reactivation Segments (R1-R9)",
    label: "Reactivation Segments (R1-R9)",
  },
  { value: "L_Rec_League_Name (1-5)", label: "L_Rec_League_Name (1-5)" },
  { value: "S_Rec_Sport_Name (1-5)", label: "S_Rec_Sport_Name (1-5)" },
];

function TargetAudiences() {
  const [trafficAllocation, setTrafficAllocation] = useState({
    controlGroup: 50,
    variant: 50,
  });

  const handleControlGroupChange = (e) => {
    let value = parseInt(e.target.value);
    if (isNaN(value)) value = 0;
    if (value > 100) value = 100;

    setTrafficAllocation({
      controlGroup: value,
      variant: 100 - value,
    });
  };

  const handleVariantChange = (e) => {
    let value = parseInt(e.target.value);
    if (isNaN(value)) value = 0;
    if (value > 100) value = 100;

    setTrafficAllocation({
      controlGroup: 100 - value,
      variant: value,
    });
  };

  return (
    <div className="target-audiences-container">
      <div className="target-audiences-header">
        <h2>Targeting Options</h2>
        <p>
          Target players by choosing multiple segments they must fall into.
          Further refine your audience by adding additional filters.
        </p>
      </div>
      <div className="target-audiences-body">
        <div className="transaction-info">
          <h3>Target Players by Segment</h3>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <Select
                defaultValue="C1 Outlier & >= 75% Churn"
                options={[
                  {
                    value: "C1 Outlier & >= 75% Churn",
                    label: "C1 Outlier & >= 75% Churn",
                  },
                  {
                    value: "C2 Outlier & 50-75% Churn",
                    label: "C2 Outlier & 50-75% Churn",
                  },
                  {
                    value: "C3 High & >= 75% Churn",
                    label: "C3 High & >= 75% Churn",
                  },
                  {
                    value: "C4 High & 50-75% Churn",
                    label: "C4 High & 50-75% Churn",
                  },
                  {
                    value: "C5 Medium & >= 75% Churn",
                    label: "C5 Medium & >= 75% Churn",
                  },
                  {
                    value: "C6 Medium & 50-75% Churn",
                    label: "C6 Medium & 50-75% Churn",
                  },
                  {
                    value: "C7 Low & >= 75% Churn",
                    label: "C7 Low & >= 75% Churn",
                  },
                  {
                    value: "C8 Low & 50-75% Churn",
                    label: "C8 Low & 50-75% Churn",
                  },
                  { value: "C9 all the rest", label: "C9 all the rest" },
                ]}
              />
            </div>
          </div>
        </div>
        <div className="transaction-info">
          <h3>Additional filters</h3>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <Select
                defaultValue={additionalFilters[0].value}
                showSearch
                options={additionalFilters}
              />
            </div>
          </div>
        </div>
        <div className="transaction-info">
          <h3>Players Location</h3>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <Select defaultValue="All states" options={statesOptions} />
            </div>
          </div>
        </div>
        <div className="ab-testing">
          <div className="ab-testing-header">
            <div className="left-content">
              <h3>A/B Testing</h3>
              <p>
                Choose what proportions of players will receive each of your
                variants and the optional Control group.
              </p>
            </div>
            <div className="right-content">
              <ToggleSwitch updateEventCode={() => {}} />
            </div>
          </div>
          <div className="ab-testing-checkbox">
            <Checkbox defaultChecked={false} onChange={() => {}} />
            <span>Has Control Group</span>
            <span>Distribute Variants Evently</span>
          </div>
          <div className="ab-testing-controller-groups">
            <div className="left-content">
              <span>Control Group</span>
              <div className="control-group-value">
                <Input
                  value={trafficAllocation.controlGroup}
                  onChange={handleControlGroupChange}
                  suffix="%"
                  style={{ fontSize: "30px", backgroundColor: "transparent" }}
                />
              </div>
            </div>
            <div className="right-content">
              <span>Variant 1</span>
              <div className="control-group-value">
                <Input
                  value={trafficAllocation.variant}
                  onChange={handleVariantChange}
                  suffix="%"
                  style={{
                    fontSize: "30px",
                    backgroundColor: "transparent",
                  }}
                />
              </div>
            </div>
          </div>
          <div className="ab-testing-controller-groups-divider">
            <div
              className="control-group"
              style={{ width: `${trafficAllocation.controlGroup}%` }}
            ></div>
            <div className="divider"></div>
            <div
              className="variant-group"
              style={{ width: `${trafficAllocation.variant}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TargetAudiences;
